import type {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import {Popover, PopoverContent, PopoverTrigger} from '@/components/ui/popover'
import {InfoGlyph} from '@/components/ui/icons'
import {AREA_TACTIL} from '@/components/ui/info-tip'

/** Abre con clic, no con hover, para que funcione igual al tacto. */
export function HelpIcon({
  label,
  children,
  testId,
  contenedor,
}: {
  /** Contextual (T11): es el `aria-label` y el nombre del popover, así que dice de qué es la ayuda. */
  label: string
  children: ReactNode
  testId?: string
  /** El `DialogContent` anfitrión: sin él el popover se porta a `document.body`, fuera del focus
   * scope, y Escape cierra el diálogo entero. */
  contenedor?: HTMLElement | null
}) {
  return (
    <Popover>
      <PopoverTrigger
        type="button"
        aria-label={label}
        data-testid={testId}
        className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-muted-foreground outline-none hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring/50 ${AREA_TACTIL}`}>
        <InfoGlyph />
      </PopoverTrigger>
      <PopoverContent container={contenedor} aria-label={label} className="p-3 text-xs text-foreground">
        {children}
      </PopoverContent>
    </Popover>
  )
}

export function GroupHeader({label, help, testId}: {label: string; help: string; testId?: string}) {
  const {t} = useTranslation()
  return (
    <p className="flex items-center gap-1.5 font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">
      {label}
      <HelpIcon label={t('common.help.iconLabelFor', {campo: label})} testId={testId}>
        {help}
      </HelpIcon>
    </p>
  )
}
